<template>
  <div class="IntervalIO">
    <box :title="$t('search')">
      <div class="pa-2">
        <DailyDatePicker @getDate="GetPersonIoInfo" />
      </div>
    </box>

    <box :title="$t('PeriodicIOList')" class="mt-2">
      <template slot="top-action-view">
        <v-icon v-if="list.length > 0 && visiblePrint" @click="print" color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div v-if="list.length > 0">
        <IntervalIOListWeb :list="list" class="hidden-sm-and-down" />
        <IntervalIOListMob :list="list" class="hidden-md-and-up" />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import IntervalIOListMob from "../../components/io/IntervalIO/IntervalIOListMob.vue";
import IntervalIOListWeb from "../../components/io/IntervalIO/IntervalIOListWeb.vue";
import Box from "../../components/widget/Box.vue";
import EmptyList from "../../components/widget/EmptyList.vue";
import EosToastType from "../../model/EosToastType";
import EosUtils from "../../utils/EosUtils";


export default {
  components: { Box, EmptyList, IntervalIOListMob, IntervalIOListWeb },
  data() {
    return {
      list: [],
      beginDate: "",
      endDate: "",
      visiblePrint: false,
    };
  },
  methods: {
    GetPersonIoInfo(date1, date2) {
      this.beginDate = date1;
      this.endDate = date2;

      if (date1 == "" || date2 == "") {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: this.$t("msg-choose-date"),
        });
        return;
      }

      const params = new URLSearchParams();
      params.append("beginDate", date1);
      params.append("endDate", date2);
      var perno = this.$store.state.auth.auth.username;
      params.append("perno", perno);

      this.$store
        .dispatch("GetPersonIoInfo", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.list = result.data;
            this.checkVisiblePrint();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
    },
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var permission = this.$store.state.personel.personelDetail.Permission;
        if (permission[19].toString() == "1") {
          this.visiblePrint = true;
        }
      }
    },
    print() {
      var dp = this.$store.state.auth.auth.username;
      let routeData = this.$router.resolve({
        name: "rpIoInfo",
        query: { BD: this.beginDate, ED: this.endDate, dp: dp },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style>
</style>